import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux'
import { store } from './redux/_helpers';
import firebase from 'firebase/compat/app';
import 'trans/i18n';


var firebaseConfig = {
  apiKey: "AIzaSyBrFPBM3-ucpq9ct4SoN-zAPQWD3vPr4YA",
  authDomain: "deliveryasap-6afcc.firebaseapp.com",
  databaseURL: "https://deliveryasap-6afcc-default-rtdb.firebaseio.com/",
  projectId: "deliveryasap-6afcc",
  storageBucket: "deliveryasap-6afcc.appspot.com",
};

firebase.initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
